import Fuse from 'fuse.js';
import { useCallback, useEffect, useRef, useState } from 'react';
import getNormalizedString from '../components/ServiceModal/private/getNormalizedString';

const fuseOptions = {
  shouldSort: true,
  threshold: 0.1,
  location: 1,
  distance: 700,
  keys: ['name'],
};

const formatSearchResults = results => results.map(item => item.item);

const useSearcher = items => {
  const [search, setSearch] = useState('');
  const [foundItems, setFoundItems] = useState([]);
  const searcher = useRef({});

  useEffect(() => {
    searcher.current = new Fuse(items, fuseOptions);
  }, [items]);

  const onSearch = useCallback(
    value => {
      const validValue = value.trim();
      if (!validValue && value) {
        return;
      }
      setSearch(value);
      setFoundItems(
        validValue.length >= 1
          ? formatSearchResults(
              searcher.current.search(getNormalizedString(validValue).trim())
            )
          : items
      );
    },
    [items]
  );

  return { search, onSearch, foundItems };
};

export default useSearcher;
